import React from 'react';
import { Table, Card, Tag } from 'antd';
import styles from './Disk.module.scss';

const PartitionInfo = ({ partitionInfo }) => {
  // 파티션 정보 파싱
  const parsePartitionInfo = (data) => {
    if (!data || data === 'N/A') return [];
    
    try {
      const partitions = [];
      const lines = data.trim().split('\n');
      
      let currentDisk = null;
      
      lines.forEach(line => {
        if (line.includes('Disk /dev/')) {
          // 새 디스크 시작
          const match = line.match(/Disk \/dev\/([^:]+): (.+)/);
          if (match) {
            currentDisk = match[1];
          }
        } else if (line.includes('/dev/') && currentDisk) {
          // 파티션 정보
          const parts = line.trim().split(/\s+/);
          if (parts.length >= 5) {
            const name = parts[0].replace('/dev/', '');
            const start = parts[1];
            const end = parts[2];
            const size = parts[3];
            const type = parts[4];
            
            partitions.push({
              disk: currentDisk,
              name,
              start,
              end,
              size,
              type,
              key: name
            });
          }
        }
      });
      
      return partitions;
    } catch (error) {
      console.error('Error parsing partition info:', error);
      return [];
    }
  };

  const partitions = parsePartitionInfo(partitionInfo);

  return (
    <Card title="파티션 정보" className={styles.diskCard}>
      <Table 
        dataSource={partitions}
        rowKey="key"
        pagination={false}
        columns={[
          { title: '디스크', dataIndex: 'disk', key: 'disk' },
          { title: '파티션', dataIndex: 'name', key: 'name',
            render: (text) => `/dev/${text}`
          },
          { title: '시작', dataIndex: 'start', key: 'start' },
          { title: '끝', dataIndex: 'end', key: 'end' },
          { title: '크기', dataIndex: 'size', key: 'size' },
          { title: '유형', dataIndex: 'type', key: 'type',
            render: (text) => {
              let color = 'default';
              if (text.includes('linux-swap')) color = 'orange';
              if (text.includes('linux')) color = 'green';
              if (text.includes('EFI')) color = 'blue';
              return <Tag color={color}>{text}</Tag>;
            }
          }
        ]}
      />
    </Card>
  );
};

export default PartitionInfo;